import AppLayout from '@/components/AppLayout.vue'
import HomeView from '@/views/home/HomeView.vue'

const routes = [
  {
    path: '/',
    component: AppLayout,
    redirect: { path: '/home' },
    meta: { title: '首页' },
    children: [
      {
        path: 'home',
        component: HomeView
      },
      {
        path: 'company',
        component: () => import('@/views/company/LayoutView.vue'),
        meta: { title: '公司管理' },
        children: [
          {
            path: '',
            component: () => import('@/views/company/ListView.vue')
          },
          {
            path: 'add',
            meta: { title: '添加公司' },
            component: () => import('@/views/company/AddView.vue')
          },
          {
            path: 'look',
            meta: { title: '公司详情' },
            component: () => import('@/views/company/LookView.vue')
          },
          {
            path: 'update',
            meta: { title: '修改公司' },
            component: () => import('@/views/company/UpdateView.vue')
          }
        ]
      },
      {
        path: 'adminUser',
        component: () => import('@/views/adminUser/LayoutView.vue'),
        meta: { title: '系统用户' },
        children: [
          {
            path: '',
            component: () => import('@/views/adminUser/ListView.vue')
          },
          {
            path: 'add',
            meta: { title: '添加用户' },
            component: () => import('@/views/adminUser/AddView.vue')
          },
          {
            path: 'update',
            meta: { title: '修改用户' },
            component: () => import('@/views/adminUser/UpdateView.vue')
          }
        ]
      },
      {
        path: 'role',
        component: () => import('@/views/role/LayoutView.vue'),
        meta: { title: '内置角色' },
        children: [
          {
            path: '',
            component: () => import('@/views/role/RoleView.vue')
          },
          {
            path: 'add',
            meta: { title: '添加角色' },
            component: () => import('@/views/role/AddView.vue')
          },
          {
            path: 'update',
            meta: { title: '修改角色' },
            component: () => import('@/views/role/UpdateView.vue')
          },
          {
            path: 'look',
            meta: { title: '查看角色' },
            component: () => import('@/views/role/LookView.vue')
          }
        ]
      },
      {
        path: 'resource',
        component: () => import('@/views/resource/LayoutView.vue'),
        meta: { title: '培训文件' },
        children: [
          {
            path: '',
            component: () => import('@/views/resource/ResourceView.vue')
          }
        ]
      },
      {
        path: 'riskIcon',
        component: () => import('@/views/risk/RiskIcon.vue'),
        meta: { title: '风险标识' }
      },
      {
        path: 'ticketTemplate',
        component: () => import('@/views/ticketTemplate/LayoutView.vue'),
        meta: { title: '票据模板' },
        children: [
          {
            path: '',
            component: () => import('@/views/ticketTemplate/TemplateView.vue')
          },
          {
            path: 'add',
            meta: { title: '添加模板' },
            component: () => import('@/views/ticketTemplate/AddView.vue')
          },
          {
            path: 'update',
            meta: { title: '修改模板' },
            component: () => import('@/views/ticketTemplate/UpdateView.vue')
          },
          {
            path: 'preview',
            meta: { title: '预览模板' },
            component: () => import('@/views/ticketTemplate/PreviewView.vue')
          }
        ]
      },
      {
        path: 'checkList',
        component: () => import('@/views/checkList/LayoutView.vue'),
        meta: { title: '排查表' },
        children: [
          {
            path: '',
            component: () => import('@/views/checkList/CheckList.vue')
          },
          {
            path: 'add',
            meta: { title: '添加排查表' },
            component: () => import('@/views/checkList/AddView.vue')
          },
          {
            path: 'update',
            meta: { title: '修改排查表' },
            component: () => import('@/views/checkList/UpdateView.vue')
          },
          {
            path: 'look',
            meta: { title: '查看排查表' },
            component: () => import('@/views/checkList/LookView.vue')
          }
        ]
      },
      {
        path: 'question',
        component: () => import('@/views/question/LayoutView.vue'),
        meta: { title: '试题管理' },
        children: [
          {
            path: '',
            component: () => import('@/views/question/QuestionView.vue')
          },
          {
            path: 'add',
            meta: { title: '添加' },
            component: () => import('@/views/question/AddView.vue')
          },
          {
            path: 'update',
            meta: { title: '修改' },
            component: () => import('@/views/question/UpdateView.vue')
          },
          {
            path: 'look',
            component: () => import('@/views/question/LookView.vue'),
            meta: { title: '查看' }
          }
        ]
      },
      {
        path: 'crm',
        meta: { title: '客户管理', layout: true },
        children: [
          {
            path: 'inquiry',
            component: () => import('@/views/crm/inquiry/LayoutView.vue'),
            meta: { title: '商务咨询' },
            children: [
              {
                path: '',
                component: () => import('@/views/crm/inquiry/ListView.vue')
              },
              {
                path: 'detail',
                meta: { title: '咨询详情' },
                children: [
                  {
                    path: '',
                    component: () => import('@/views/crm/inquiry/DetailView.vue')
                  }
                ]
              }
            ]
          },
          {
            path: 'lead',
            component: () => import('@/views/crm/lead/LayoutView.vue'),
            meta: { title: '销售线索' },
            children: [
              {
                path: '',
                component: () => import('@/views/crm/lead/ListView.vue')
              },
              {
                path: 'detail',
                meta: { title: '线索详情' },
                children: [
                  {
                    path: '',
                    component: () => import('@/views/crm/lead/DetailView.vue')
                  }
                ]
              }
            ]
          },
          {
            path: 'opportunity',
            component: () => import('@/views/crm/opportunity/LayoutView.vue'),
            meta: { title: '商机管理' },
            children: [
              {
                path: '',
                component: () => import('@/views/crm/opportunity/ListView.vue')
              },
              {
                path: 'detail',
                meta: { title: '商机详情' },
                children: [
                  {
                    path: '',
                    component: () => import('@/views/crm/opportunity/DetailView.vue')
                  }
                ]
              }
            ]
          },
          {
            path: 'customer',
            component: () => import('@/views/crm/customer/LayoutView.vue'),
            meta: { title: '客户档案' },
            children: [
              {
                path: '',
                component: () => import('@/views/crm/customer/ListView.vue')
              },
              {
                path: 'detail',
                meta: { title: '客户详情' },
                children: [
                  {
                    path: '',
                    component: () => import('@/views/crm/customer/DetailView.vue')
                  }
                ]
              },
              {
                path: 'add',
                meta: { title: '新增客户' },
                component: () => import('@/views/crm/customer/FormView.vue')
              },
              {
                path: 'edit',
                meta: { title: '编辑客户' },
                component: () => import('@/views/crm/customer/FormView.vue')
              }
            ]
          },
          {
            path: 'contract',
            component: () => import('@/views/crm/contract/LayoutView.vue'),
            meta: { title: '合同管理' },
            children: [
              {
                path: '',
                component: () => import('@/views/crm/contract/ListView.vue')
              },
              {
                path: 'detail',
                meta: { title: '合同详情' },
                children: [
                  {
                    path: '',
                    component: () => import('@/views/crm/contract/DetailView.vue')
                  }
                ]
              }
            ]
          },
          {
            path: 'order',
            component: () => import('@/views/crm/order/LayoutView.vue'),
            meta: { title: '订单管理' },
            children: [
              {
                path: '',
                component: () => import('@/views/crm/order/ListView.vue')
              },
              {
                path: 'detail',
                meta: { title: '订单详情' },
                children: [
                  {
                    path: '',
                    component: () => import('@/views/crm/order/DetailView.vue')
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/LoginView.vue')
  },
  {
    path: '/error',
    component: () => import('@/views/ErrorView.vue')
  },
  {
    path: '/:pathMatch(.*)*', // 404
    component: () => import('@/views/404.vue'),
    props: (route) => ({ url: route.fullPath })
  }
]

export default routes
